import { AxiosRequestConfig, AxiosResponse } from 'axios'
import HttpClient from '../http-client'
import { httpConfig } from '../constants'
import { Run } from '../model/models'

export class RunAPI extends HttpClient {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig)
    this.getRuns = this.getRuns.bind(this)
  }

  public getRuns(): Promise<Run[]> {
    const endpoint = `/runs`
    return this.get<Run[]>(endpoint)
      .then((response: AxiosResponse<Run[]>) =>
        response.data.map((r) => ({
          id: r.id,
          runAt: new Date(r.runAt),
        })),
      )
      .catch((error) => {
        throw error
      })
  }

  public getCWIOccupations(runId: number): Promise<Record<string, Record<string, string[]>>> {
    const endpoint = `/ofa-cwi/cwi-occupations/run/${runId}`
    return this.get<Record<string, Record<string, string[]>>>(endpoint)
      .then((response: AxiosResponse<Record<string, Record<string, string[]>>>) => response.data)
      .catch((error) => {
        throw error
      })
  }
}

export const runAPI = new RunAPI(httpConfig)
